import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6deaef76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-navbars-breadcrumb-user-link" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_Search = _resolveComponent("Search")!

  return (_openBlock(), _createElementBlock("div", {
    class: "layout-navbars-breadcrumb-user",
    style: _normalizeStyle({ flex: $setup.layoutUserFlexNum })
  }, [
    _createVNode(_component_el_dropdown, {
      "show-timeout": 70,
      "hide-timeout": 50,
      onCommand: $setup.onHandleCommandClick
    }, {
      dropdown: _withCtx(() => [
        _createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_dropdown_item, { command: "logOut" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('message.user.dropdown5')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, [
          _createTextVNode(_toDisplayString($setup.getUserInfos.userName === '' ? 'test' : $setup.getUserInfos.userName) + " ", 1),
          _hoisted_2
        ])
      ]),
      _: 1
    }, 8, ["onCommand"]),
    _createVNode(_component_Search, { ref: "searchRef" }, null, 512)
  ], 4))
}